module.exports = __webpack_public_path__ + "img/skycabinet.5da4c2df.png";